export default "__VITE_ASSET__58582103__"